import { render } from "./oauth-login.vue?vue&type=template&id=64205f39&scoped=true"
import script from "./oauth-login.vue?vue&type=script&lang=js"
export * from "./oauth-login.vue?vue&type=script&lang=js"

import "./oauth-login.vue?vue&type=style&index=0&id=64205f39&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64205f39"]])

export default __exports__